var _style, _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1.9 -1.6 3.8 3.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty {\n      fill: none;\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 0,
    cy: 0,
    r: 1,
    stroke: "#000000",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-right",
    d: "         M0 -0.5         q0.6 0 0.86 0.5         q-0.3 0.5 -0.86 0.5       "
  }), /*#__PURE__*/React.createElement("path", {
    id: "pupil-right",
    d: "         M0 -0.5         q0.3 0.5 0 1       "
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(0, -0.5)",
    fill: "goldenrod"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(0, 0.5)",
    fill: "darkslateblue"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(-0.86, 0.0)",
    fill: "goldenrod"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate( 0.86, 0.0)",
    fill: "darkslateblue"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eye-right",
    fill: "goldenrod"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eye-right",
    transform: "scale(-1)",
    fill: "darkslateblue"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pupil-right",
    fill: "darkslateblue"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pupil-right",
    transform: "scale(-1)",
    fill: "goldenrod"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(0, -0.5)",
    className: "empty"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(0, 0.5)",
    className: "empty"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate(-0.86, 0.0)",
    className: "empty"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#circle",
    transform: "translate( 0.86, 0.0)",
    className: "empty"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/eye-filled.aa0f2f277d7f43195251d98816238429.svg";
export { ForwardRef as ReactComponent };